import type { UseCase } from '@/core/shared'
import type { ChargePointRepository } from '../domain'

export const createChargePoint: UseCase<ChargePointRepository, 'createChargePoint'> = (repository) => {
  return async (chargePoint) => {
    await repository.createChargePoint(chargePoint)
  }
}
